var profilePage = document.querySelector('div.profile');

if (profilePage) {
  // head
  var head = profilePage.querySelector('.profile__wrap');
  var prevScroll = profilePage.scrollTop,
      curScroll,
      direction = '',
      prevDirection = 0; // profilePage.addEventListener('scroll', function (event) {
  //   curScroll = profilePage.scrollTop;
  //   if (curScroll > prevScroll) {
  //     direction = 'down';
  //   } else if (curScroll < prevScroll) {
  //     direction = 'up';
  //   }
  //   if (direction !== prevDirection) {
  //     if (direction === 'down' && curScroll > head.offsetHeight) {
  //       profilePage.classList.add('hide');
  //       prevDirection = direction;
  //     } else if (direction === 'up') {
  //       profilePage.classList.remove('hide');
  //       prevDirection = direction;
  //     }
  //   }
  //   prevScroll = curScroll;
  // }, true);
  // about

  profilePage.querySelector('.profile__about a').addEventListener('click', function (event) {
    profilePage.classList.add('profile--opened');
    document.querySelectorAll('.menu__wrapper').forEach(function (menu) {
      menu.classList.remove('opened');
    });
    document.documentElement.classList.remove('menu--opened');
  });
  profilePage.querySelector('.profile__detail a').addEventListener('click', function (event) {
    profilePage.classList.remove('profile--opened');
    document.querySelectorAll('.menu__wrapper').forEach(function (menu) {
      menu.classList.remove('opened');
    });
    document.documentElement.classList.remove('menu--opened');
  });
}